import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { LazyMotion, domAnimation, m } from 'framer-motion';
import Login from './pages/Login';
import Home from './pages/Home';
import Register from './pages/Register';
import NewEnquiry from './pages/NewEnquiry';
import ViewEnquiries from './pages/ViewEnquiries';
import SplashScreen from './components/SplashScreen';
import SanitaryProductView from './components/SanitaryProductView';
import SurfaceProductView from './components/SurfaceProductView';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  font-family: 'Poppins', sans-serif;
`;

const PageWrapper = styled(m.div)`
  width: 100%;
  min-height: 100vh;
`;

const dummyProductData = {
  code: 'PCS/SUR/TIL/2435',
  images: [
    '/images/colored-realistic-ceramic-floor-tiles-horizontal-set-with-squares-different-types-styles-tiles_1284-29013.jpg',
    '/images/3d-rendering-luxury-modern-living-room-with-leather-sofa-lamp_105762-2255.jpg',
    '/images/traditional-house-architecture_23-2151050966.jpg',
  ],
  details: {
    technical: {
      material: 'Porcelain',
      colorTexture: 'gray',
      variation: 'No',
      repetition: 'Yes',
      recommendation: 'Wall/Floor',
      traffic: 'Medium',
      edgean: 'Normal',
      spacer: '2',
      recommendedAdhesive: '5',
      recommendedGrout: 'Thin',
      antiSlip: 'yes',
    },
    size: {
      length: '520.00',
      width: '170.00',
      tesseraSize: '124.90',
      thickness: '0.00',
      dia: '0.00',
    },
    options: {
      colorOption: 'Blue',
      sizeOption: '70.00',
    },
  },
};

function AppRoutes() {
  const location = useLocation();

  return (
    <PageWrapper
      key={location.pathname}
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
    >
      <Routes location={location}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/home" element={<Home />} />
        <Route path="/new-enquiry" element={<NewEnquiry />} />
        <Route path="/view-enquiries" element={<ViewEnquiries />} />
        <Route 
          path="/surface-product-view" 
          element={
            <SurfaceProductView 
              onClose={() => {}} 
              onShortlist={() => {}} 
              productData={dummyProductData} 
            />
          } 
        />
        <Route 
          path="/sanitary-product-view" 
          element={
            <SanitaryProductView 
              onClose={() => {}} 
              onShortlist={() => {}} 
              productData={dummyProductData} 
            />
          } 
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </PageWrapper>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load Poppins font
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Simulate splash screen loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
      document.head.removeChild(link);
    };
  }, []);

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <LazyMotion features={domAnimation}>
      <AppContainer>
        <Router>
          <AppRoutes />
        </Router>
      </AppContainer>
    </LazyMotion>
  );
}

export default App; 